import { render } from "./ChooseLang.vue?vue&type=template&id=59e77aaa&scoped=true"
import script from "./ChooseLang.vue?vue&type=script&lang=js"
export * from "./ChooseLang.vue?vue&type=script&lang=js"

import "./ChooseLang.vue?vue&type=style&index=0&id=59e77aaa&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e77aaa"]])

export default __exports__